export default {
    dayNav: {
        prevDay: 'Previous day (Alt+←)',
        nextDay: 'Next day (Alt+→)',
    },
}
